function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("g", {
  "data-name": "Layer 1",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M24.93 20h72v5h-72z"
}), React.createElement("path", {
  d: "M83.28 71.33H35.64a1.45 1.45 0 00-.88.29L14 86.72l3.85-13.48a1.47 1.47 0 00-.25-1.31 1.49 1.49 0 00-1.2-.6A13.44 13.44 0 013 57.9V16.44A13.45 13.45 0 0116.43 3h88.36a13.45 13.45 0 0113.43 13.44v14h3v-14A16.46 16.46 0 00104.79 0H16.43A16.46 16.46 0 000 16.44V57.9a16.46 16.46 0 0014.48 16.32L10 90.09a1.49 1.49 0 002.32 1.62l23.81-17.38h47.15z"
}), React.createElement("path", {
  d: "M24.93 53h58.34v5H24.93zm62.01-16.5h-62v5h59.24a16.61 16.61 0 012.76-5zm101.13-3.11H99.71a13.45 13.45 0 00-13.43 13.44v41.46a13.45 13.45 0 0013.43 13.43h69.15a1.56 1.56 0 01.88.28l20.73 15.11-3.85-13.48a1.49 1.49 0 011.44-1.91 13.45 13.45 0 0013.44-13.43V46.83a13.45 13.45 0 00-13.43-13.44zm-10.82 52.92h-72v-5h72zm0-16.5h-72v-5h72zm0-16.5h-72v-5h72z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 201.5 117.11"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/support.svg";
export { SvgComponent as ReactComponent };